import { TextColumns } from "@phosphor-icons/react";

import {
  DropdownMenu,
  DropdownMenuCheckbox,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuList,
  DropdownMenuTrigger,
} from "common/components/ui/DropdownMenu";
import FilterButton from "common/components/ui/FilterButton";
import { typedObjectEntries } from "common/helpers/utils";

import type { Icon } from "@phosphor-icons/react";
import type { VisibilityState } from "@tanstack/react-table";

export interface VisibilityColumn {
  label: string;
  icon?: Icon;
}

interface ColumnsVisibilityControlProps {
  /** Keyed by column id, in the order they should be listed. */
  columns: Record<string, VisibilityColumn>;
  columnVisibility: VisibilityState;
  setColumnVisibility: (columnVisibility: VisibilityState) => void;
}

/**
 * Table-instance free columns filter. Only needs the hidable columns and the
 * visibility state, so it can be rendered anywhere that state is available.
 */
export default function ColumnsVisibilityControl({
  columns,
  columnVisibility,
  setColumnVisibility,
}: ColumnsVisibilityControlProps) {
  function toggleColumnVisibility(columnId: string) {
    setColumnVisibility({
      ...columnVisibility,
      [columnId]: !columnVisibility[columnId],
    });
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <FilterButton leftIcon={<TextColumns />} size="sm" className="ml-auto">
          Columns
        </FilterButton>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" size="sm">
        <DropdownMenuList isScrollable={false}>
          {typedObjectEntries(columns).map(([id, { label, icon: Icon }]) => (
            <DropdownMenuItem
              key={id}
              className="group/checkbox"
              onSelect={(e) => {
                e.preventDefault();
                toggleColumnVisibility(id);
              }}
            >
              <DropdownMenuCheckbox
                isChecked={columnVisibility[id]}
                onCheckedChange={() => toggleColumnVisibility(id)}
              />

              {Icon && <Icon weight="fill" />}
              {label}
            </DropdownMenuItem>
          ))}
        </DropdownMenuList>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
